<template>
  <van-row class="page-wrapper indicators-history-page" justify="center">
    <van-col class="itserve-center history-items" span="24">
      <template v-if="hasIndicationsHistory">
        <template v-for="(indication, index) in indicationsHistory">
          <section :key="indication.id || index" class="indications-card">
            <div class="indications-card__icon" aria-hidden="true">
              <svg viewBox="0 0 64 64">
                <path d="M15 12h34v40H15z" />
                <path d="M23 22h18M23 31h18M23 40h10" />
                <path d="m39 42 4 4 8-10" />
              </svg>
            </div>

            <div class="indications-card__content">
              <div class="indications-card__row">
                <span class="indications-card__label">
                  {{
                    $t("regionalEnergy.indicatorsHistorySearchResults.period")
                  }}
                </span>
                <strong class="indications-card__value">
                  {{ indication.last_date_month }}
                </strong>
              </div>

              <div class="indications-card__row">
                <span class="indications-card__label">
                  {{
                    $t(
                      "regionalEnergy.indicatorsHistorySearchResults.indications"
                    )
                  }}
                </span>
                <strong class="indications-card__value indications-card__meter">
                  {{
                    indication.grm_meter_reading ||
                    $t("regionalEnergy.sendIndications.no_grm_data")
                  }}
                </strong>
              </div>
            </div>
          </section>
        </template>
        <div class="history-bottom-spacer" aria-hidden="true"></div>
      </template>
      <template v-else>
        <div class="history-empty place-content-center">
          <info-message class="apply-loader">
            {{ $t("global.noData") }}
          </info-message>
        </div>
      </template>
    </van-col>
  </van-row>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";

export default {
  name: "IndicatorsHistorySearchResults",
  components: { InfoMessage },
  computed: {
    hasIndicationsHistory() {
      return (
        Array.isArray(this.indicationsHistory) &&
        this.indicationsHistory.length > 0
      );
    },
    indicationsHistory() {
      return this.$store.state.IndicationsHistory.indicators;
    },
  },
  created() {
    this.loadIndicationsHistory();
  },
  data() {
    return {
      searchQuery: this.$route.params,
    };
  },
  methods: {
    async loadIndicationsHistory() {
      const account = this.$route.params.account || this.$route.params.ls;

      if (!account) {
        return;
      }

      await this.$store.dispatch(
        "IndicationsHistory/getLastIndications",
        account
      );
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100%;
  background-color: transparent;
}

.indicators-history-page {
  padding: 14px 0 44px;
}

.history-items {
  width: calc(100% - 24px);
  max-width: 414px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.indications-card {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  margin: 0 0 10px;
  padding: 13px 14px;
  border: 1px solid rgba(46, 74, 112, 0.58);
  border-radius: 12px;
  background: linear-gradient(
      145deg,
      rgba(16, 22, 34, 0.98),
      rgba(11, 16, 26, 0.98)
    ),
    #0e121b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.indications-card__icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(35, 112, 255, 0.2);
  color: #ffffff;
}

.indications-card__icon svg {
  width: 29px;
  height: 29px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.indications-card__content {
  min-width: 0;
}

.indications-card__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
}

.indications-card__row + .indications-card__row {
  margin-top: 5px;
  padding-top: 9px;
  border-top: 1px solid rgba(45, 67, 98, 0.48);
}

.indications-card__label {
  min-width: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.2;
}

.indications-card__value {
  flex: 0 0 auto;
  color: #ffffff;
  font-size: 16px;
  font-weight: 850;
  line-height: 1.15;
  text-align: right;
}

.indications-card__meter {
  color: #7fb0ff;
}

.history-empty {
  padding: 24px 12px;
}

.history-bottom-spacer {
  width: 100%;
  height: calc(124px + env(safe-area-inset-bottom, 0px));
  flex: 0 0 auto;
}

@media (max-width: 360px) {
  .history-items {
    width: calc(100% - 16px);
  }

  .indications-card {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: 10px;
    padding: 12px 11px;
  }

  .indications-card__icon {
    width: 38px;
    height: 38px;
  }

  .indications-card__icon svg {
    width: 26px;
    height: 26px;
  }

  .indications-card__label {
    font-size: 13px;
  }

  .indications-card__value {
    font-size: 15px;
  }
}
</style>
